module.exports = __webpack_public_path__ + "img/east.83ef2646.png";